import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import Loader from 'components/common/Loader';
import { Link } from 'react-router-dom';
import ThemedButton from 'common/ThemedButton';
import DescriptionIcon from 'images/icons/icn-description.svg';
import GET_ORDER from '../../../api/queries/GET_ORDER';
import downloadFile from '../../../utils/downloadUtils';
import './OrderCorrection.scss';
const OrderCorrection = ({ order }) => {
    var _a, _b, _c;
    const { i18n: { language }, t, } = useTranslation('orders');
    const { data, loading } = useQuery(GET_ORDER, {
        variables: {
            id: order.id,
        },
    });
    const onClickExport = useCallback(() => downloadFile(`/export/getOrderCorrectionComparison/${order.id}/${language}`), [language, order.id]);
    return loading ? (React.createElement(Loader, { size: 40 })) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "OrderCorrection" }, (data === null || data === void 0 ? void 0 : data.node.correctedOrder) ? (React.createElement("div", { className: "flex items-center justify-between" },
            React.createElement("p", null,
                t('corrected_order'),
                ":",
                ' ',
                React.createElement(Link, { to: `/orders/${(_a = data === null || data === void 0 ? void 0 : data.node.correctedOrder) === null || _a === void 0 ? void 0 : _a.id}` }, (_b = data === null || data === void 0 ? void 0 : data.node.correctedOrder) === null || _b === void 0 ? void 0 : _b.orderId),
                ' ',
                "(",
                t(`status.${(_c = data === null || data === void 0 ? void 0 : data.node.correctedOrder) === null || _c === void 0 ? void 0 : _c.status}`),
                ")"),
            React.createElement(ThemedButton, { key: "export", icon: React.createElement(DescriptionIcon, null), className: "exportButton", onClick: onClickExport }, t('generate_differences_summary')))) : (React.createElement("p", null, t('no_corrected_order'))))));
};
export default OrderCorrection;
